import { render, staticRenderFns } from "./message-controller.vue?vue&type=template&id=67ec0225&scoped=true&"
import script from "./message-controller.vue?vue&type=script&lang=js&"
export * from "./message-controller.vue?vue&type=script&lang=js&"
import style0 from "./message-controller.vue?vue&type=style&index=0&id=67ec0225&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ec0225",
  null
  
)

export default component.exports